import {Component} from "@angular/core";
import {NavbarComponent} from "../../../components/navbar/navbar.component";
import {TranslateModule} from "@ngx-translate/core";

@Component({
  selector: 'hidden-map-header',
  standalone: true,
  imports: [
    NavbarComponent,
    TranslateModule
  ],
  styleUrl: '../hidden-map.cmp.scss',
  templateUrl: 'hidden-map-header.html'
})
export class HiddenMapHeader {
}
